module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving15_dettaglio-fa24a08002e4b03066d30054e885d347.jpg";